import { render, staticRenderFns } from "./CurriculumResources.vue?vue&type=template&id=0f87e4dd&scoped=true"
import script from "./CurriculumResources.vue?vue&type=script&lang=js"
export * from "./CurriculumResources.vue?vue&type=script&lang=js"
import style0 from "./CurriculumResources.vue?vue&type=style&index=0&id=0f87e4dd&prod&lang=less&scoped=true"
import style1 from "./CurriculumResources.vue?vue&type=style&index=1&id=0f87e4dd&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f87e4dd",
  null
  
)

export default component.exports